import { Flex, Heading, Icon, Text } from "@chakra-ui/react"
import React from "react"
import { useTranslation } from "react-i18next"
import { FiUpload } from "react-icons/fi"
import { useCloudProviderContext } from "../hooks/useCloudProviderContext"
import { useImagePicker } from "./hooks/useImagePicker"

interface Props {}

const CloudBrowserContentDesktop: React.FC<Props> = () => {
  const { t } = useTranslation()
  const {
    closeCloudProviderModal,
    imageRegionId,
    lineItemId,
    productId,
    setIsImportingImages,
  } = useCloudProviderContext()

  const onStartImporting = () => {
    setIsImportingImages(true)
  }

  const onCompleteImporting = () => {
    setIsImportingImages(false)
    closeCloudProviderModal()
  }

  const { getInputProps, getRootProps } = useImagePicker({
    onCompleteImporting,
    onStartImporting,
    imageRegionId,
    lineItemId,
    productId,
  })

  return (
    <Flex
      flex={1}
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Flex
        flex={1}
        maxHeight="200px"
        borderWidth={2}
        borderRadius="xl"
        borderStyle="dashed"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        gap={2}
        p={8}
        id="image-upload-field"
        data-testid="image-upload-field"
        className="ImageUpload_svg"
        _hover={{ backgroundColor: "blackAlpha.50" }}
        {...getRootProps()}
      >
        <input {...getInputProps()} />
        <Icon as={FiUpload} boxSize="10" />
        <Heading as="h3" fontSize="xl">
          Select Photos
        </Heading>
        <Text textAlign="center">
          {t("components.blocks.ImageUploadBlock.UploadFromDevice")}
        </Text>
      </Flex>
    </Flex>
  )
}

export default CloudBrowserContentDesktop
